export default [
  {
    path: '/b2bhub/apoio-vendas/hierarquia-representantes',
    name: 'hierarquia-representantes',
    component: () => import('@/views/app/representantes/HierarquiaRepresentantes.vue'),
    meta: {
      pageTitle: 'Hierarquia de Representantes',
      action: 'read',
      resource: 'HierarquiaRepresentantes',
    },
  },
];
